import { AbstractRequestClass, DetailRequestModel } from './abstract-request.class';
import { AvailabilityPropertyMappingRequest } from './abstract-request.constants';
import { DataObject } from '../../../../../../models/data-object.models';

export class AvailabilityPropertyAssociationRequestClass extends AbstractRequestClass {
  public getMultiEndPoints(): DetailRequestModel[] | null {
    return null;
  }
  public getMappingRequest(): DataObject {
    return AvailabilityPropertyMappingRequest;
  }
}
